<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @cancel="handleCancel"
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': true} }"
    :okDisabled=true
    :cancelText="language['common.closeButton']">
    <emp-role-app-user-list-form ref="realForm" :roleId="this.roleId" :roleName="this.roleName"></emp-role-app-user-list-form>
    <template slot="footer">
      <a-button @click="handleCancel">{{language['common.closeButton']}}</a-button>
    </template>
  </j-modal>
</template>

<script>

  import EmpRoleAppUserListForm from './EmpRoleAppUserListForm'
  export default {
    name: 'EmpRoleAppUserListModal',
    components: {
      EmpRoleAppUserListForm
    },
    data () {
      return {
        title:'',
        width:1200,
        visible: false,
        disableSubmit: true,
        roleId: '',
        roleName: '',
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },
      listdetail (roleId,roleName) {
        this.visible = true;
        this.roleId = roleId;
        this.roleName = roleName;
        this.disableSubmit = true;
      },
    }
  }
</script>